import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';
import { InlineSVGModule } from 'ng-inline-svg';

import { WorkflowRoutingModule } from './workflow-routing.module';
import { WorkflowListComponent } from './workflow-list/workflow-list.component';
import { WorkflowAccordionComponent } from './workflow-accordion/workflow-accordion.component';
import { WorkflowCardComponent } from './workflow-card/workflow-card.component';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateWorkflowDialogComponent } from './create-workflow-dialog/create-workflow-dialog.component';
import { WorkflowService } from './_services/workflow.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormioModule } from 'angular-material-formio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { WorkflowFilterComponent } from './workflow-list/workflow-filter/workflow-filter.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';

import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormioModule } from 'angular-formio';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DynamicFiltersComponent } from './workflow-list/workflow-filter/dynamic-filters.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CreatePatientDialogComponent } from '../apps/lists/patients/patient-add-dialog/patient-add.dialog.component';
import { CreateContactDialogComponent } from '../../partials/content/general/contact-add-dialog/contact-add.dialog.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  ContactEffects,
  contactsReducer,
  DoctorEffects,
  doctorsReducer,
  DrugEffects,
  DrugGroupService,
  DrugService,
  drugsReducer,
  PatientEffects,
  patientsReducer,
  PrescriptionEffects,
  PrescriptionService,
  prescriptionsReducer,
} from 'src/app/core/lists';
import { PrescriptionEditComponent } from '../apps/lists/patients/_subs/prescription-edit/prescription-edit.component';
import { CreateDoctorDialogComponent } from '../apps/lists/doctors/doctor-add-dialog/doctor-add.dialog.component';
import { CreateDrugDialogComponent } from '../apps/lists/drugs/drug-add-dialog/drug-add.dialog.component';
import { OfficesService } from 'src/app/core/management';
import { CancelWorkflowDialogComponent } from './cancel-workflow-dialog/cancel-workflow-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ConfirmActionDialogComponent } from '../../partials/content/crud';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateModule } from '@ngx-translate/core';
import { inboxReducer } from 'src/app/core/events';
import { ErrorInterceptor } from '../../../core/auth/_helpers/error.interceptor';
import { AuthInterceptor } from '../auth/auth.interceptor';
import { CoreModule } from 'src/app/core/core.module';
import { PartialsModule } from '../../partials/partials.module';
import { CommentsService } from 'src/app/core/services/comments.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { EntityRelationshipEditComponent } from '../apps/lists/doctors/relationships/relationship-edit/entity-relationship-edit.component';
import { WorkflowModReviewComponent } from './workflow-mod-review/workflow-mod-review.component';
import { WorkflowHistoryComponent } from './workflow-history/workflow-history.component';
import { WorkflowAddStandardComponent } from './workflow-add-standard/workflow-add-standard.component';
import { WorkflowAddProcessNavResourceDialogComponent } from './workflow-add-process-nav-resource-dialog/workflow-add-process-nav-resource-dialog.component';
import { WorkflowAddBlockerDialogComponent } from './workflow-add-blocker-dialog/workflow-add-blocker-dialog.component';
import { OpenPdfComponent } from './open-pdf/open-pdf.component';
import { WorkflowStatusColumnComponent } from './workflow-status-column/workflow-status-column.component';
import { WorkflowAccordionDashboardComponent } from './workflow-accordion-dashboard/workflow-accordion-dashboard.component';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  entryComponents: [
    ConfirmActionDialogComponent,
    CreateWorkflowDialogComponent,
    CreatePatientDialogComponent,
    CreateContactDialogComponent,
    PrescriptionEditComponent,
    CreateDrugDialogComponent,
    CreateDoctorDialogComponent,
    CancelWorkflowDialogComponent,
    OpenPdfComponent,
    EntityRelationshipEditComponent,
    WorkflowModReviewComponent,
    WorkflowAddStandardComponent,
    WorkflowAddProcessNavResourceDialogComponent,
    WorkflowAddBlockerDialogComponent,
  ],
  declarations: [
    OpenPdfComponent,
    WorkflowListComponent,
    WorkflowCardComponent,
    WorkflowAccordionComponent,
    CreateWorkflowDialogComponent,
    WorkflowFilterComponent,
    CancelWorkflowDialogComponent,
    DynamicFiltersComponent,
    WorkflowModReviewComponent,
    WorkflowHistoryComponent,
    WorkflowAddStandardComponent,
    WorkflowAddProcessNavResourceDialogComponent,
    WorkflowAddBlockerDialogComponent,
    WorkflowStatusColumnComponent,
    WorkflowAccordionDashboardComponent,
  ],
  imports: [
    MatInputModule,
    InlineSVGModule,
    MatButtonModule,
    MatGridListModule,
    CommonModule,
    WorkflowRoutingModule,
    MatCardModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormioModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatRippleModule,
    MatNativeDateModule,
    PerfectScrollbarModule,
    FormsModule,
    HttpClientModule,
    FormioModule,
    NgxPermissionsModule.forChild(),
    NgxExtendedPdfViewerModule,
    NgbDropdownModule,
    DragDropModule,
    TranslateModule,
    CoreModule,
    StoreModule.forFeature('contacts', contactsReducer),
    EffectsModule.forFeature([ContactEffects]),
    StoreModule.forFeature('patients', patientsReducer),
    EffectsModule.forFeature([PatientEffects]),
    StoreModule.forFeature('doctors', doctorsReducer),
    EffectsModule.forFeature([DoctorEffects]),
    StoreModule.forFeature('drugs', drugsReducer),
    EffectsModule.forFeature([DrugEffects]),
    StoreModule.forFeature('prescriptions', prescriptionsReducer),
    EffectsModule.forFeature([PrescriptionEffects]),
    StoreModule.forFeature('inbox', inboxReducer),
    PartialsModule,
    MatExpansionModule,
    MatPaginatorModule,
  ],
  providers: [
    WorkflowService,
    DrugService,
    DrugGroupService,
    PrescriptionService,
    OfficesService,
    CommentsService,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  exports: [CreateWorkflowDialogComponent, WorkflowListComponent],
})
export class WorkflowModule {}
